import React from 'react';
import { InputNumber } from 'antd';

function NumberInput({ ...rest }) {
  return <InputNumber {...rest} />;
}

export default NumberInput;
